<template>
  <v-hover v-slot="{ hover }">
    <v-card
        class="mx-auto my-2 pa-4 overflow-hidden"
        :width=width
        :height=height
        elevation="2"
        rounded
        outlined
        :style="hover ? 'border: 2px solid #3F51B5' : ''"
    >
      <router-link :to="{name: 'notification', params: { id: item.id }}">
        <v-overlay v-if="hover" absolute color="clear"></v-overlay>
      </router-link>
      <v-row no-gutters justify="space-around">
        <v-col cols="5" align="left">
          <v-chip v-if="'人事'===item.category" small color="primary" class="font-weight-bold mb-2">{{
              item.category
            }}
          </v-chip>
          <v-chip v-else small color="green" text-color="white" class="font-weight-bold mb-2">{{
              item.category
            }}
          </v-chip>
        </v-col>
        <v-col align="right">
          <div class="text-caption ">更新日時:{{ item.contributedAt }}</div>
        </v-col>
      </v-row>
      <div class="text-subtitle-2 text-xl-h6">{{ item.title }}</div>
      <v-divider/>
      <vue-markdown class="text-caption mt-4">
        {{ item.body }}
      </vue-markdown>
    </v-card>
  </v-hover>
</template>

<script>
import VueMarkdown from 'vue-markdown';

export default {
  name: 'NotificationListItem',

  components: {
    'vue-markdown': VueMarkdown,
  },

  props: {
    // 表示するおしらせ
    item: {
      type: Object,
      required: true,
    },
    height: {
      type: Number,
      default: 250,
    },
    width: {
      type: Number,
      default: 300,
    },
  },
};
</script>

<style scoped lang="scss">

</style>